import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  dialogContent: {
    flex: "1",
    // padding: "20px 10px 10px",
    backgroundColor: "#FFFFFF",
    minWidth: window.isMobileView ? "100%": "1150px",
    maxWidth: window.isMobileView ? "100%": "1150px",
  },
  box: {
    display: "flex",
    flexFlow: "column",
    height: "100%",
    // padding: "18px 10px 10px 20px",
    padding: "0px 0px 15px 0px",
  },
  header: {
    flex: "0 1 auto",
    display: "flex",
    padding: "15px 10px",
    alignItems: "baseline",
    backgroundColor: "#454545",
    cursor: "move",
    justifyContent: "space-between",
  },
  content: {
    flex: "1 1 auto",
    // maxHeight: "580px",
    // overflow: "auto",
    marginBottom: "10px",
    padding: "10px 20px",
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: "10px",
    justifyContent: "space-between",
    borderBottom: "1px solid #F1F1F1",
    backgroundColor: "#DFEEFF",
    padding: "0 10px",
  },
  shippingLayout: {
    "& .custom-label": {
      // marginTop: '10px !important',
    },
  },
  textEditor: {
    "& .public-DraftEditor-content": {
      minHeight: "160px",
      maxHeight: "160px",
    },
  },
  marginTopTwenty: {
    marginTop: "25px",
  },
  cardHeaderTitle: {
    display: "flex",
    alignItems: "center",
  },
  container: {
    paddingRight: "25px",
  },
  footer: {
    flex: "0 1 40px",
    gap: "10px",
    padding: "0 20px",
  },
  footerRight: {
    float: "right",
    marginRight: "-8px",
    display: "flex",
    gap: "10px",
    marginTop: "10px",
  },
  crossButton: {
    position: "relative",
    top: "-12px",
    right: "10px",
    cursor: "pointer",
    padding: "3px",
    zIndex: "2",
    display: "block",
    "& :hover": {
      backgroundColor: "#F4F4F4",
    },
  },
  closeIcon: {
    cursor: "pointer",
    color: "white",
  },
  title: {
    fontFamily: "Lato",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "20px",
    lineHeight: "24px",
    color: "#FFFFFF",
    letterSpacing: "0.02em",
  },
  labelText: {
    fontFamily: "Lato",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "20px",
    color: "#3C4549",
    padding: "14px 0px 5px",
  },
  valueText: {
    fontFamily: "Lato",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "20px",
    color: "#3C4549",
    padding: "6px 0",
    textTransform: "capitalize",
  },
  backBtn: {
    fontSize: "14px",
    lineHeight: "16px",
    fontWeight: 600,
    color: "#454545",
    borderRadius: "4px",
    padding: "8px 16px",
    textTransform: "uppercase",
    border: "1px solid #454545",
  },

  greenBtn: {
    fontSize: "18px",
    lineHeight: "16px",
    fontWeight: 400,
    cursor: "pointer",
    backgroundColor: "#63af00",
    borderRadius: "4px",
    marginRight: "5px",
    padding: "8px 16px",
    textTransform: "capitalize",
    cursor: "pointer",
    color: "#ffffff",
    boxShadow:
      "0px 0px 4px rgba(0, 0, 0, 0.14), 0px 3px 4px rgba(58, 58, 68, 0.12)",

    "&:hover": {
      color: "#ffffff",
      background: "#454545",
    },
  },

  changeBtn: {
    fontSize: "14px",
    lineHeight: "16px",
    fontWeight: 600,
    cursor: "pointer",
    backgroundColor: "#454545",
    borderRadius: "4px",
    marginRight: "5px",
    padding: "8px 16px",
    textTransform: "uppercase",
    cursor: "pointer",
    color: "#ffffff",
    boxShadow:
      "0px 0px 4px rgba(0, 0, 0, 0.14), 0px 3px 4px rgba(58, 58, 68, 0.12)",
    "&:hover": {
      color: "#ffffff",
      background: "#454545",
    },
  },
  emailFooter: {
    borderTop: "1px solid #e0e0e0",
    padding: "12px 0px 5px 0px",
    "& p": {
      marginBottom: 0,
    },
    "& img": {},
  },
  templateFooter: {
    background: "#282827",
    padding: "5px 11px",
    marginTop: "15px",
    "& p": {
      margin: 0,
      color: "white",
      display: "flex",
      fontSize: "13px",
      alignItems: "center",
      justifyContent: "center",
    },
  },

  templateFooter2: {
    background: "#282827",
    padding: "20px 15px",

    "& p": {
      margin: 0,
      color: "white",
      display: "flex",
      fontSize: "13px",
      alignItems: "center",
      justifyContent: "center",
      paddingTop: "10px",
    },
  },
  secHeading: {
    color: "#4F4F4F",
    fontSize: "16px",
    lineHeight: "12px",
    padding: "12px 6px",
    borderBottom: "1px solid #BBBEBF",
    width: "100%",
    marginBottom: "15px",
    fontFamily: "Lato",
    fontWeight: 600,
  },
  selectBaseInput: {
    width: "100%",
    display: "flex",
    boxSizing: "border-box",
    margin: "5px 0px 5px",
    backgroundColor: "white",
    minHeight: "35.63px",
    padding: "0px 8px 0px 12px",
    height: "35.63px",
    opacity: "0.7",
    border: "0.5px solid #777D80",
    borderRadius: "4px",

    "& .MuiInputBase-input": {
      padding: "0px 24px 0px 12px",
      minHeight: "35.63px",
      fontSize: "14px",
      color: "#4A4A4A",
      "&:focus": {
        background: "transparent",
        borderRadius: "4px",
        outline: 0,
      },
      "&:before": {
        borderBottom: "none !important",
      },
    },
    "& .MuiInput-underline:before": {
      borderBottom: "none",
    },

    "& .Mui-disabled": {
      backgroundColor: "#f3f3f3",
      color: "#4A4A4A",
    },
    "& input::-webkit-outer-spin-button": {
      appearance: "none",
      margin: 0,
    },
    "& input::-webkit-inner-spin-button": {
      appearance: "none",
      margin: 0,
    },
    "& input[type=number]": {
      appearance: "textfield",
    },
  },
  brandBox: {
    color: "white",
    textAlign: "center",
    minHeight: "198px",
    display: "flex",
    flexFlow: "column",
    margin: "auto",
    "& img": {
      maxWidth: "125px",
      margin: "auto",
    },
    "& h2": {
      fontSize: "16px",
      fontFamily: "Lato",
      fontWeight: "bold",
      color: "white",
      width: "85%",
      margin: "20px auto",
    },
  },
  templateContainer: {
    margin: "auto",
    "& .tempHeader": {
      background: "#3A5A9C",
      padding: "5px",
      display: "flex",
      alignItems: "center",
      "& img": {
        maxWidth: "120px",
        padding: "5px",
      },
    },
    "& .tempHeaderBottom": {
      background: "#EDEDED",
      textAlign: "center",
      padding: "10px",
      fontSize: "16px",
      "& h3": {
        margin: 0,
      },
    },
    "& .tempContent": {
      padding: "15px",
      "& h1": {
        fontSize: "22px",
      },
      "& p": {
        margin: "5px 0px",
      },
    },
    "& img": {
      //   width: '100%',
    },
  },
  donateSection: {
    padding: "30px",
    backgroundColor: "#282827",
    textAlign: "center",
    color: "white",
    "& h3": {
      color: "white",
    },
  },
  donateSectionTem3: {
    padding: "30px",
    backgroundColor: "#282827",
    textAlign: "center",
    color: "white",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    backgroundOrigin: "border-box",
    backgroundPositionX: "70px",

    "& h3": {
      color: "white",
    },
    "& span": {
      color: "#df614a",
    },
    "& Button": {
      color: "#df614a",
      cursor: "pointer",
      padding: "12px 24px",
      fontSize: "18px",
      boxShadow:
        "0px 0px 4px rgba(0, 0, 0, 0.14), 0px 3px 4px rgba(58, 58, 68, 0.12)",
      fontWeight: "400",
      lineHeight: "16px",
      marginRight: "5px",
      borderRadius: "10px",
      textTransform: "capitalize",
      backgroundColor: "white",
      "&:hover": {
        color: "#ffffff",
        background: "#454545",
      },
    },
  },
  donateSectionTem6: {
    padding: "30px",
    backgroundColor: "#df614a",
    textAlign: "center",
    color: "white",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    backgroundOrigin: "border-box",
    backgroundPositionX: "70px",

    "& h3": {
      color: "white",
    },
    "& span": {
      color: "#white",
    },
    "& Button": {
      color: "#df614a",
      cursor: "pointer",
      padding: "12px 24px",
      fontSize: "18px",
      boxShadow:
        "0px 0px 4px rgba(0, 0, 0, 0.14), 0px 3px 4px rgba(58, 58, 68, 0.12)",
      fontWeight: "400",
      lineHeight: "16px",
      marginRight: "5px",
      borderRadius: "10px",
      textTransform: "capitalize",
      backgroundColor: "white",
      "&:hover": {
        color: "#ffffff",
        background: "#454545",
      },
    },
  },
  SocialIcons: {
    display: "flex",
    justifyContent: "center",
    gap: "20px",
    padding: "15px",
    "& img": {
        width:"20%",
    },
    "& a": {
        textAlign: "center",
    }
  },
}));
